import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@material-tailwind/react";
import { API_URL } from "../../App.js";
import "./latest_news.css";


function LatestNews ({ noticiasPerPages = 5 }) {
  const [noticias, setNoticias] = useState([]);
  const navigate = useNavigate();

  function formatearFecha(fechaString) {
    const opciones = { year: "numeric", month: "long", day: "numeric" };
    const fecha = new Date(fechaString);
    return fecha.toLocaleDateString("es-ES", opciones);
  }

  useEffect(() => {
    fetch(API_URL)
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "success") {
          setNoticias(data.data.noticias.slice(0, noticiasPerPages));
        }
      })
      .catch((error) => {
        console.error("Error al obtener las noticias:", error);
      });
  }, [noticiasPerPages]);

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    // Eliminar etiquetas HTML
    const textOnly = text.replace(/<[^>]*>/g, "");
    if (textOnly.length <= maxLength) {
      return textOnly;
    }
    return textOnly.substring(0, maxLength) + "...";
  };

  const handleClick = (id) => {
    navigate(`/noticiaID/${id}`);
  };

  const handleVerTodas = () => {
    navigate("/news");
  };

  if (noticias.length === 0) {
    return (
      <section className="noticias-revista-container">
        <p className="text-center text-gray-500">Cargando noticias...</p>
      </section>
    );
  }

  const noticiaPrincipal = noticias[0];
  const noticiasSecundarias = noticias.slice(1, 5);

  return (
    <section className="noticias-revista-container">
      <div className="noticias-revista-grid">
        {/* Noticia Principal - Grande (posición 1) */}
        <article 
          className="noticia-principal noticia-1"
          onClick={() => handleClick(noticiaPrincipal.id)}
        >
          <div className="noticia-principal-imagen">
            <img
              src={`https://adalab.unillanos.edu.co/media/${noticiaPrincipal.imagen_portada}`}
              alt={noticiaPrincipal.titulo}
            />
            <div className="noticia-principal-overlay">
              <span className="noticia-etiqueta">Destacado</span>
            </div>
          </div>
          <div className="noticia-principal-contenido">
            <span className="noticia-fecha">
              {formatearFecha(noticiaPrincipal.fecha_creacion)}
            </span>
            <h2 className="noticia-principal-titulo">
              {noticiaPrincipal.titulo}
            </h2>
            <p className="noticia-principal-extracto">
              {truncateText(noticiaPrincipal.contenido, 250)}
            </p>
            <span className="noticia-leer-mas">Leer más →</span>
          </div>
        </article>

        {/* Noticias Secundarias (posiciones 2, 3, 4, 5) */}
        {noticiasSecundarias.map((noticia, index) => (
          <article
            key={noticia.id}
            className={`noticia-secundaria noticia-${index + 2}`}
            onClick={() => handleClick(noticia.id)}
          >
            <div className="noticia-secundaria-imagen">
              <img
                src={`https://adalab.unillanos.edu.co/media/${noticia.imagen_portada}`}
                alt={noticia.titulo}
              />
            </div>
            <div className="noticia-secundaria-contenido">
              <span className="noticia-fecha">
                {formatearFecha(noticia.fecha_creacion)}
              </span>
              <h3 className="noticia-secundaria-titulo">
                {noticia.titulo}
              </h3>
              <p className="noticia-secundaria-extracto">
                {truncateText(noticia.contenido, 380)}
              </p>
              <span className="noticia-leer-mas">Leer más →</span>
            </div>
          </article>
        ))}
      </div>

      {/* Botón Ver todas */}
      <div className="noticias-revista-footer">
        <Button 
          className="bg-colorPrincipal hover:bg-colorSecudario font-sans"
          onClick={handleVerTodas}
        >
          Ver todas las noticias
        </Button>
      </div>
    </section>
  );
}

export default LatestNews;
